import { Injectable } from '@angular/core';

@Injectable()

export class FileUploadService {
  private files: { file: File, title: string }[] = [];

  addFile(file: File, title: string): void {
    this.files.push({ file, title });
  }

  getFiles(): { file: File, title: string }[] {
    return this.files;
  }

  clearFiles(): void {
    this.files = [];
  }
}



// WEBPACK FOOTER //
// /usr/src/app/src/app/_services/FileUploadService.ts